import React from "react";
import styles from "./alert.module.css";
import classNames from "classnames"
import closeIcon from "./close1.png"
import icSuccess from "./ic_success.png";
import icFail from "./ic_fail.png"

const Alert = props =>(
    <div className={styles.promptBackground}>
        <div className={styles.promptAlertBackground}>
            <img className={styles.img} src={props.status==1?icSuccess:icFail}/>
            <div>{props.msg}</div>

        </div>
    </div>
)
export default Alert;
